module.exports = __webpack_public_path__ + "img/9e505b4.svg";